
export class ConfigurationGabaritSpecifiquePage {
    public readonly estAfficherTiroirPrimeurs: boolean;
    public readonly estAfficherMenuDroite: boolean;
    public readonly estMenuDroiteEpuree: boolean;
    public readonly identifiantMenuDroiteActif: string | undefined;
    public readonly identifiantAideContact: string | undefined;
    public readonly identifiantEntete: string | undefined;

    constructor(estAfficherTiroirPrimeurs: boolean, 
            estAfficherMenuDroite: boolean, 
            estMenuDroiteEpuree: boolean, 
            identifiantMenuDroiteActif: string | undefined, 
            identifiantAideContact: string | undefined, 
            identifiantEntete: string | undefined) {
        this.estAfficherTiroirPrimeurs = estAfficherTiroirPrimeurs;
        this.estAfficherMenuDroite = estAfficherMenuDroite;
        this.estMenuDroiteEpuree = estMenuDroiteEpuree;
        this.identifiantMenuDroiteActif = identifiantMenuDroiteActif;
        this.identifiantAideContact = identifiantAideContact;
        this.identifiantEntete = identifiantEntete;
    }

    public obtenirConfigurationsTiroirPrimeurs() {
        return {
            consultation: {
                afficherTiroirPrimeurs: this.estAfficherTiroirPrimeurs
            }
        };
    }

    public obtenirConfigurationsAfficherMenuDroite() {
        return {
            consultation: {
                afficherMenuDroite: this.estAfficherMenuDroite,
            }
        };
    }

    public obtenirConfigurationsAvecMenuDroiteEpuree() {
        return {
            consultation: {
                afficherSondageCaisse: !this.estMenuDroiteEpuree,
                afficherLogoAssuranceDepot: !this.estMenuDroiteEpuree,
                afficherLiensUtiles: !this.estMenuDroiteEpuree,
            }
        };
    }

    public obtenirConfigurationsAvecIdentifiantMenuDroite() {
        return {
            consultation: {
                menuPrincipal: {
                    identifiantMenu: this.identifiantMenuDroiteActif,
                }
            }
        };
    }

    public obtenirConfigurationsAideContact() {
        return {
            consultation: {
                aideContactV2: {
                    identifiantMenu: this.identifiantAideContact
                }
            }
        };
    }

    public obtenirConfigurationsIdentifiantEntete() {
        return {
            consultation: {
                entetePage: {
                    identifiantMenu: this.identifiantEntete
                }
            }
        };
    }
}
